var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartLinkEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_27944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.25 24.429V29.25",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 47.25H29.571",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75 47.25H64.929",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.692 32.55L32.787 36.642",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.808 32.55L61.713 36.642",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 47.2501C58.5021 45.2213 57.9556 43.2297 56.9183 41.4862C55.881 39.7427 54.3915 38.3121 52.6076 37.3459C50.8237 36.3798 48.8117 35.914 46.7847 35.9979C44.7576 36.0818 42.791 36.7123 41.0931 37.8226C39.3951 38.9329 38.029 40.4817 37.1393 42.305C36.2497 44.1283 35.8697 46.1583 36.0395 48.1799C36.2093 50.2016 36.9226 52.1397 38.1039 53.789C39.2853 55.4384 40.8906 56.7376 42.75 57.5491V63.0001H51.75V57.5491C53.7551 56.6752 55.4617 55.2354 56.6607 53.4061C57.8596 51.5767 58.4989 49.4373 58.5 47.2501Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.75 69.75H51.75",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 20.25V5.60401C58.4921 4.71017 58.1308 3.85576 57.4951 3.22736C56.8594 2.59895 56.0009 2.2476 55.107 2.25001H5.625C4.7359 2.2476 3.88195 2.59706 3.24962 3.22209C2.61728 3.84712 2.25792 4.69694 2.25 5.58601V46.143C2.25713 47.0374 2.61804 47.8925 3.25384 48.5216C3.88964 49.1506 4.74861 49.5024 5.643 49.5H15.75",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13.5H58.5",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_27944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartLinkEmpty);
export default __webpack_public_path__ + "static/media/smart-link-empty.f99475815756e5d78c57be2324d0b571.svg";
export { ForwardRef as ReactComponent };